import { RootState } from '../index'

export const selectAzureAuthorityUrl = (state: RootState) => state.general.azureAuthorityUrl

export const selectClientId = (state: RootState) => state.general.clientId

export const selectIsMobileDevice = (state: RootState) => state.general.isMobileDevice
